/** @jsxImportSource theme-ui */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Flex, Button, Text } from '@infotrack/zenith-ui';
import type { LocationStateType } from '../types/navigation';
import {
  headerContainerStyles,
  leftSectionStyles,
  rightSectionStyles,
} from './topFiveDetailHeader.styles';

type TopFiveDetailHeaderProps = {
  hasPendingChanges?: boolean;
  onCancel?: () => void;
  onUpdate?: () => void;
  isUpdating?: boolean;
};

export const TopFiveDetailHeader = ({
  hasPendingChanges = false,
  onCancel,
  onUpdate,
  isUpdating = false,
}: TopFiveDetailHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackClick = () => {
    const referrerParams = new URLSearchParams(location.search);
    const backUrl = `/topfive${referrerParams.toString() ? `?${referrerParams.toString()}` : ''}`;
    navigate(backUrl, { state: { fromDetail: true } } as LocationStateType);
  };

  return (
    <Flex role="banner" sx={headerContainerStyles}>
      <Flex sx={leftSectionStyles}>
        {/* Logo */}
        <Text variant="hero" color="primary/600">
          iTop5
        </Text>
      </Flex>

      <Flex sx={rightSectionStyles}>
        {/* Show Cancel/Update buttons when there are pending changes, hide Back button */}
        {hasPendingChanges ? (
          <>
            <Button
              variant="secondary"
              size="small"
              onClick={onCancel}
              disabled={isUpdating}
              aria-label="Cancel changes"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              size="small"
              onClick={onUpdate}
              loading={isUpdating}
              disabled={!hasPendingChanges}
              aria-label="Save changes"
            >
              Update
            </Button>
          </>
        ) : (
          <Button
            iconProps={{ name: 'arrow_back' }}
            variant="secondary"
            size="small"
            onClick={handleBackClick}
            aria-label="Back to TOP 5 list"
          >
            Back
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
